import {IntegrationCard, IntegrationSectionHeader, IntegrationDeleteDialog} from '../IntegrationDesign';
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Box,
    Tooltip,
    IconButton
} from "@mui/material";
import Spinner from "../../../spinner/Spinner";
import {DeleteOutlined, EditOutlined} from "@mui/icons-material";
import React, {useState} from "react";

function RsocIntegrations(props) {

    const {deleteIntegration, integration, history, location, clear} = props;

    const [prompt, setPrompt] = useState(false);
    const [deleteIntegrationId, setDeleteIntegrationId] = useState(0);

    const edit = (rowData) => {

        clear();

        if (rowData?.networkType === "rsoc_system1") {
            history.push({
                pathname: "/settings/integrations/rsoc-system1/" + parseInt(rowData?.id),
                state: {background: location}
            });
        }
        if (rowData?.networkType === "rsoc_amg") {
            history.push({
                pathname: "/settings/integrations/rsoc-amg/" + parseInt(rowData?.id),
                state: {background: location}
            });
        }
        if (rowData?.networkType === "rsoc_ads_com") {
            history.push({
                pathname: "/settings/integrations/rsoc-ads-com/" + parseInt(rowData?.id),
                state: {background: location}
            });
        }
        if (rowData?.networkType === "rsoc_predicto") {
            history.push({
                pathname: "/settings/integrations/rsoc-predicto/" + parseInt(rowData?.id),
                state: {background: location}
            });
        }
        if (rowData?.networkType === "rsoc_airfind") {
            history.push({
                pathname: "/settings/integrations/rsoc-airfind/" + parseInt(rowData?.id),
                state: {background: location}
            });
        }
        if (rowData?.networkType === "rsoc_explorads") {
            history.push({
                pathname: "/settings/integrations/rsoc-explorads/" + parseInt(rowData?.id),
                state: {background: location}
            });
        }
        if (rowData?.networkType === "rsoc_tonic") {
            history.push({
                pathname: "/settings/integrations/rsoc-tonic/" + parseInt(rowData?.id),
                state: {background: location}
            });
        }
        if (rowData?.networkType === "rsoc_sedo") {
            history.push({
                pathname: "/settings/integrations/rsoc-sedo/" + parseInt(rowData?.id),
                state: {background: location}
            });
        }
        if (rowData?.networkType === "rsoc_inuvo_prism" || rowData?.networkType === "rsoc_inuvo_standard") {
            history.push({
                pathname: "/settings/integrations/rsoc-inuvo-prism/" + parseInt(rowData?.id),
                state: {background: location}
            });
        }
        if (rowData?.networkType === "rsoc_prices") {
            history.push({
                pathname: "/settings/integrations/rsoc-prices/" + parseInt(rowData?.id),
                state: {background: location}
            });
        }
    };

    const addIntegration = () => {
        props.history.push({
            pathname: "/settings/integrations/add-rsoc",
            state: {background: props.location}
        });
    };

    const handleDeletePrompt = (id) => {
        setDeleteIntegrationId(id);
        setPrompt(true);
    };

    const handleDeleteIntegration = (prompt) => {
        if (!prompt) {
            setPrompt(false);
            return false;
        } else {
            deleteIntegration(deleteIntegrationId);
            setPrompt(false);
        }
    };

    return (
        <Box sx={{minWidth: 0}}>
            <IntegrationCard elevation={0}>
                {integration?.loading?.rsocIntegrations && <Spinner overComponentBox={true}/>}
                <IntegrationSectionHeader title="Revenue sync · RSOC"
                                          count={integration?.loading?.rsocIntegrations ? undefined : integration?.rsocIntegrations?.length}
                                          description="Connect your related search providers and sync revenue."
                                          onAdd={addIntegration}/>

                {prompt &&
                    <IntegrationDeleteDialog question="Delete integration?"
                                             text={`Remove "${integration?.rsocIntegrations?.find(row => row.id === deleteIntegrationId)?.networkName || 'this integration'}" from Skro?`}
                                             confirm={handleDeleteIntegration}/>
                }

                <TableContainer sx={{maxHeight: "400px"}}>
                    <Table stickyHeader size="small" aria-label="rsoc-integrations">
                        <TableHead sx={{whiteSpace: "nowrap"}}>
                            <TableRow hover>
                                <TableCell>Network Name</TableCell>
                                <TableCell>Actions</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody sx={{whiteSpace: "nowrap"}}>
                            {integration?.rsocIntegrations?.map((row) => (
                                <TableRow key={row?.id}>
                                    <TableCell sx={{width: "100%"}}>{row?.networkName}</TableCell>
                                    <TableCell>
                                        <Box display="flex" flexWrap="nowrap" alignItems="center"
                                             justifyContent="right">
                                            <Box mr={1}>
                                                <Tooltip title="Edit">
                                                <span>
                                                    <IconButton
                                                        size="small"
                                                        color="inherit"
                                                        onClick={() => edit(row)}
                                                        aria-label="edit"
                                                    >
                                                        <EditOutlined fontSize="small" color="inherit"/>
                                                    </IconButton>
                                                </span>
                                                </Tooltip>
                                            </Box>
                                            <Box>
                                                <Tooltip title="Delete">
                                                <span>
                                                    <IconButton
                                                        size="small"
                                                        color="inherit"
                                                        onClick={() => handleDeletePrompt(row?.id)}
                                                        aria-label="delete"
                                                    >
                                                        <DeleteOutlined fontSize="small" color="error"/>
                                                    </IconButton>
                                                </span>
                                                </Tooltip>
                                            </Box>
                                        </Box>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </IntegrationCard>
        </Box>
    );

}

export default RsocIntegrations;
